import { localize } from "@/i18n/translate";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { scrollToTop } from "@/lib/scroll";
import { Reveal } from "@/components/site/Reveal";
import { useContent } from "@/i18n/LangContext";
export const LegalLayout = ({
  title,
  intro,
  children,
  testId
}) => {
  const {
    ui
  } = useContent();
  useEffect(() => {
    scrollToTop();
  }, []);
  useEffect(() => {
    document.title = `${title} – Swiss Blockchain Alliance`;
    return () => {
      document.title = ui.title;
    };
  }, [title, ui.title]);
  return <article data-testid={testId} className="mx-auto max-w-[1440px] px-5 pb-24 pt-[120px] sm:px-8 md:pb-32 md:pt-[160px] lg:px-12">
      <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm font-medium text-ink hover:text-signal">
        <ArrowLeft className="h-4 w-4" aria-hidden="true" /> {localize(ui.legal.back)}
      </Link>
      <div className="mt-10 grid grid-cols-12 gap-x-6 gap-y-10">
        <Reveal className="col-span-12 lg:col-span-4">
          <h1 className="font-display text-4xl font-extrabold leading-[0.95] tracking-[-0.04em] sm:text-5xl lg:text-6xl">{localize(title)}</h1>
          {localize(intro && <p className="mt-6 max-w-sm leading-relaxed text-mute">{localize(intro)}</p>)}
        </Reveal>
        <div className="col-span-12 space-y-12 lg:col-span-7 lg:col-start-6">{localize(children)}</div>
      </div>
    </article>;
};
export const Block = ({
  title,
  children
}) => <section className="border-t border-ink/15 pt-6">
    <h2 className="font-display text-xl font-bold tracking-[-0.01em] md:text-2xl">{localize(title)}</h2>
    <div className="mt-4 space-y-3 leading-relaxed text-mute [&_a]:text-ink [&_a]:underline [&_a]:underline-offset-4 [&_a:hover]:text-signal [&_li]:ml-5 [&_li]:list-disc">
      {localize(children)}
    </div>
  </section>;
